document.addEventListener("turbolinks:load", function() {
    if($("body").data("controller") == "admin_users") {

        $("#btn-save-admin_user").on("click", function() {
            $("#form-admin_user").validate()
        })

    }
})